import React from 'react';
import { SettingsPageLayoutProps } from './types';
import { styles } from './styles';

const SettingsPageLayout: React.FC<SettingsPageLayoutProps> = ({ title, actions, children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          <span>{title}</span>
        </h1>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default SettingsPageLayout;
export type { SettingsPageLayoutProps } from './types';
